import React from 'react';

export default function Checkbox({ label, checked, onChange, children ,policy,isStart}) {
  return (
    <label className={`flex  gap-2 cursor-pointer select-none ${policy ? '!items-start' : ''}`}>
      <input type="checkbox" checked={checked} onChange={onChange} className="hidden" />
      <span className={`!w-[18px] min-w-[18px] !h-[18px] rounded-check border-[1px] border-[#E6E6E6] flex items-center justify-center shadow-[0px_1px_2px_0px_#0000000D] ${checked ? 'bg-[#5D4A9D] text-white' : 'bg-[#F5F5F5]'}`}>{checked ? '' : ''}</span>
      {children ? (
        <span className={`${isStart ? 'md:items-center items-start block ' : 'items-center flex'} !text-start text-[#151515] text-[16px]   font-[400]   gap-1`}>{children}</span>
      ) : (
        <span className={`${isStart ? 'md:items-center items-start block ' : 'items-center flex'} !text-start text-[#151515] text-[16px]   font-[400]   gap-1`}>{label}</span>
      )}
    </label>
  );
}